import { render } from "./Team.vue?vue&type=template&id=0838b402&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=0838b402&scoped=true&lang=css"
import "./Team.vue?vue&type=style&index=1&id=0838b402&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0838b402"]])

export default __exports__